/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FrontEndSelectValue } from './FrontEndSelectValue';
import {
    FrontEndSelectValueFromJSON,
    FrontEndSelectValueFromJSONTyped,
    FrontEndSelectValueToJSON,
    FrontEndSelectValueToJSONTyped,
} from './FrontEndSelectValue';

/**
 * 
 * @export
 * @interface ProjectOrderStatusSettings
 */
export interface ProjectOrderStatusSettings {
    /**
     * 
     * @type {Array<FrontEndSelectValue>}
     * @memberof ProjectOrderStatusSettings
     */
    all?: Array<FrontEndSelectValue>;
    /**
     * 
     * @type {Array<FrontEndSelectValue>}
     * @memberof ProjectOrderStatusSettings
     */
    completed?: Array<FrontEndSelectValue>;
    /**
     * 
     * @type {Array<FrontEndSelectValue>}
     * @memberof ProjectOrderStatusSettings
     */
    received?: Array<FrontEndSelectValue>;
    /**
     * 
     * @type {Array<FrontEndSelectValue>}
     * @memberof ProjectOrderStatusSettings
     */
    cancelled?: Array<FrontEndSelectValue>;
}

/**
 * Check if a given object implements the ProjectOrderStatusSettings interface.
 */
export function instanceOfProjectOrderStatusSettings(value: object): value is ProjectOrderStatusSettings {
    return true;
}

export function ProjectOrderStatusSettingsFromJSON(json: any): ProjectOrderStatusSettings {
    return ProjectOrderStatusSettingsFromJSONTyped(json, false);
}

export function ProjectOrderStatusSettingsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectOrderStatusSettings {
    if (json == null) {
        return json;
    }
    return {
        
        'all': json['all'] == null ? undefined : ((json['all'] as Array<any>).map(FrontEndSelectValueFromJSON)),
        'completed': json['completed'] == null ? undefined : ((json['completed'] as Array<any>).map(FrontEndSelectValueFromJSON)),
        'received': json['received'] == null ? undefined : ((json['received'] as Array<any>).map(FrontEndSelectValueFromJSON)),
        'cancelled': json['cancelled'] == null ? undefined : ((json['cancelled'] as Array<any>).map(FrontEndSelectValueFromJSON)),
    };
}

export function ProjectOrderStatusSettingsToJSON(json: any): ProjectOrderStatusSettings {
    return ProjectOrderStatusSettingsToJSONTyped(json, false);
}

export function ProjectOrderStatusSettingsToJSONTyped(value?: ProjectOrderStatusSettings | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'all': value['all'] == null ? undefined : ((value['all'] as Array<any>).map(FrontEndSelectValueToJSON)),
        'completed': value['completed'] == null ? undefined : ((value['completed'] as Array<any>).map(FrontEndSelectValueToJSON)),
        'received': value['received'] == null ? undefined : ((value['received'] as Array<any>).map(FrontEndSelectValueToJSON)),
        'cancelled': value['cancelled'] == null ? undefined : ((value['cancelled'] as Array<any>).map(FrontEndSelectValueToJSON)),
    };
}

